module.exports = __webpack_public_path__ + "static/media/document.61948712.svg";